export default {
  id: 81,
  title: 'Target #81 - Odoo',
  url: 'https://cssbattle.dev/play/81',
  colors: ['#191919', '#714B67', '#8F8F8F'],
  solution:
    '<p a><p b><p c><p d><p e><style>body{background:#191919}p{position:fixed;top:106;width:40;height:40;border:20px solid #8f8f8f;border-radius:1in}[a]{border-color:#714b67;left:37}[b]{left:119}[c]{left:201}[d]{left:283}[e]{width:20;height:70;border:none;background:#8f8f8f;top:86;left:179}</style>',
}
